export default "__VITE_ASSET__C7_nXKRF__"